import * as React from 'react';
import { useIntl } from 'react-intl';
import RidebookForm from './form';
import useAnalytics from '../../../hooks/useAnalytics';

interface IVehicleGroupFormProps {
  actionUrl: string;
  formats: string[];
  fileName: string;
  dates: Date[] | null;
}

export default function Ridebook(props: IVehicleGroupFormProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [isOpenMenu, setIsOpenMenu] = React.useState<boolean>(false);
  const [isRidebookFormOpen, setIsRidebookFormOpen] = React.useState<boolean>(false);
  const { trackEvent } = useAnalytics();

  const handleEscapeKey = React.useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        if (isOpenMenu) {
          setIsOpenMenu(false);
        }
      }
    },
    [isOpenMenu]
  );

  const handleClickOutside = React.useCallback(
    (event: any) => {
      const { id } = event.target;
      if (isOpenMenu && id !== 'ridebookExportSelect' && id !== 'print' && id !== 'angle-down') {
        setIsOpenMenu(false);
      }
    },
    [isOpenMenu]
  );

  React.useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    window.addEventListener('keydown', handleEscapeKey);
    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('keydown', handleEscapeKey);
    };
  });

  const prepareRidebook = () => {
    setIsRidebookFormOpen(!isRidebookFormOpen);
    trackEvent(['ride book', 'click', 'Open ride book generate form']);
  };

  return (
    <>
      <a
        onClick={prepareRidebook}
        href="#"
        className="e-button e-button--square px-2"
        data-cy="ride-book-book-of-rides-open"
      >
        <i className="cmd-icons cmd-icon-download-3 mr-2 text-gray-lighten" />
        {f({ id: 'menu.bookOfRides/ride_book' })}
      </a>
      {isRidebookFormOpen && (
        <div style={{ textAlign: 'left' }}>
          <RidebookForm
            closeCallback={prepareRidebook}
            fileName={props.fileName}
            actionUrl={props.actionUrl}
            formats={props.formats}
            dates={props.dates}
          />
        </div>
      )}
    </>
  );
}
